export default __webpack_public_path__ + "static/media/img3.2018835d.jpeg";